import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ParticleField } from './ParticleField';
interface LoadingProps {
  onComplete: () => void;
}
const loadingTexts = ['Analizando conexión…', 'Detectando química…', 'Descubriendo experiencia ideal…'];
export function Loading({
  onComplete
}: LoadingProps) {
  const [textIndex, setTextIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const textInterval = setInterval(() => {
      setTextIndex(prev => (prev + 1) % loadingTexts.length);
    }, 1200);
    // ~2.5s total: 100 steps * 25ms
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setTimeout(onComplete, 400);
          return 100;
        }
        return prev + 2;
      });
    }, 50);
    return () => {
      clearInterval(textInterval);
      clearInterval(progressInterval);
    };
  }, [onComplete]);
  return <motion.div className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 overflow-hidden" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} data-id="element-19">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/kmiNARVmivQadPNC9Z6Djd/descarga_(4).jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'grayscale(100%) contrast(1.1) blur(50px)',
      opacity: 0.2
    }} data-id="element-20" />

      <ParticleField data-id="element-21" />

      <div className="relative z-10 max-w-md w-full flex flex-col items-center space-y-12" data-id="element-22">
        {/* Animated Circle */}
        <motion.div className="relative w-32 h-32" animate={{
        rotate: 360
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-23">
          <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-24">
            <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" data-id="element-25" />
            <motion.circle cx="50" cy="50" r="45" fill="none" stroke="url(#gradient)" strokeWidth="3" strokeLinecap="round" strokeDasharray="283" strokeDashoffset={283 - 283 * progress / 100} style={{
            transformOrigin: 'center'
          }} data-id="element-26" />
            <defs data-id="element-27">
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-28">
                <stop offset="0%" stopColor="#FF2D6F" data-id="element-29" />
                <stop offset="100%" stopColor="#B91C3C" data-id="element-30" />
              </linearGradient>
            </defs>
          </svg>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-31">
            <span className="text-2xl font-bold text-glow" data-id="element-32">
              {Math.round(progress)}%
            </span>
          </div>
        </motion.div>

        {/* Loading Text */}
        <AnimatePresence mode="wait" data-id="element-33">
          <motion.p key={textIndex} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.4
        }} className="text-xl font-medium text-center text-white/80" data-id="element-34">
            {loadingTexts[textIndex]}
          </motion.p>
        </AnimatePresence>

        {/* Progress Bar */}
        <div className="w-full max-w-xs" data-id="element-35">
          <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden" data-id="element-36">
            <motion.div className="h-full bg-gradient-to-r from-accent-pink to-accent-red" initial={{
            width: 0
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 0.3,
            ease: 'easeOut'
          }} data-id="element-37" />
          </div>
        </div>
      </div>
    </motion.div>;
}